import { EscalationFilters, IEscalatedPageDetailModel, IEscalationStatusesCount } from "../../Models/escalatedPageModels";

export const AGENT_FIRST_NAME_KEY: keyof IEscalatedPageDetailModel = "userFirstName";
export const AGENT_LAST_NAME_KEY: keyof IEscalatedPageDetailModel = "userLastName";
export const APPLICANT_FIRST_NAME_KEY: keyof IEscalatedPageDetailModel = "firstName";
export const APPLICANT_LAST_NAME_KEY: keyof IEscalatedPageDetailModel = "lastName";

export const AGENT_NAME_LABEL = "Agent Name";
export const APPLICANT_NAME_LABEL = "Applicant Name";

export const HIDDEN_COMBINED_NAME_KEYS = new Set<keyof IEscalatedPageDetailModel>([
    AGENT_LAST_NAME_KEY,
    APPLICANT_LAST_NAME_KEY
]);

export const ESCALATION_TBL_DEFAULT_COLS = ["Escalation Status", "Escalation Type", "Escalated By", "Escalated At", "Opportunity Uid", AGENT_NAME_LABEL, APPLICANT_NAME_LABEL];

export const IS_MAIL_SENT_KEY = 'isMailSent' as const;
export const CREATED_BY_KEY = 'createdBy' as const;
export const STATUS_KEY = 'status' as const;
export const ESCALATION_TYPE_KEY = 'escalationType' as const;
export const CREATED_AT_KEY = 'createdAt' as const;
export const CUSTOM_START_DATE_KEY = 'customStartDate' as const;
export const CUSTOM_END_DATE_KEY = 'customEndDate' as const;

export const OPEN_STATUS_ID = 0 as const;
export const OVERDUE_STATUS_ID = 1 as const;
export const CLOSED_STATUS_ID = 2 as const;

export const DEFAULT_ESCALATION_STATUS_COUNT: IEscalationStatusesCount[] = [
    { id: OPEN_STATUS_ID, status: 'Open', applicationsCount: 0 },
    { id: OVERDUE_STATUS_ID, status: 'Overdue', applicationsCount: 0 },
    { id: CLOSED_STATUS_ID, status: 'Closed', applicationsCount: 0 }
];

export enum EscalationStatus {
    OPEN = "open",
    OVERDUE = "overdue",
    CLOSED = "closed",
}

export const STATUS_COLORS = {
    [EscalationStatus.OPEN]: "#B80000",
    [EscalationStatus.OVERDUE]: "#FF7134",
    [EscalationStatus.CLOSED]: "#5C5C5C",
    "default": "#000",
}

export const BASE_ESCALATION_FILTERS: EscalationFilters = {
    status: [OPEN_STATUS_ID.toString(), OVERDUE_STATUS_ID.toString()],
    escalationType: [],
    isMailSent: false
};  

export const enum PAGINATION {
    DEFAULT_ROWS_PER_PAGE = 20,
    DEFAULT_PAGE = 1,
}